import {COUNTRY_CODES} from './constants/globalConstants';

export const showGtinFeature = (countryCode) => {
  const allowedMarkets = [COUNTRY_CODES.MEXICO];
  const isGtinEnabled = allowedMarkets.includes(countryCode);

  return isGtinEnabled;
};

export const showTierConfigurationsFeature = (countryCode) => {
  const allowedMarkets = [COUNTRY_CODES.MEXICO];
  return allowedMarkets.includes(countryCode);
};

export const isBlobTierImageUploadEnabled = (countryCode) => {
  const excludedMarkets = [COUNTRY_CODES.COLOMBIA];
  return !excludedMarkets.includes(countryCode);
};
